module.exports = "/_next/static/images/collaborate-b35d91e1cf55e6731031709dd384c06e.png";